/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Gallery_UploadingInputs */

const cs_gallery_uploading = /** @type {(inputs: Gallery_UploadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nahrávám ${i?.current} z ${i?.total}`)
};

const en_gallery_uploading = /** @type {(inputs: Gallery_UploadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploading ${i?.current} of ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Uploading {current} of {total}" |
*
* @param {Gallery_UploadingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_uploading = /** @type {((inputs: Gallery_UploadingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_UploadingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_uploading(inputs)
	return cs_gallery_uploading(inputs)
});